module.exports = __webpack_public_path__ + "img/arrow-bar-down.f6bb8fb1.svg";